<template>
	<el-dialog :title="info.baoming==0?'活动需求调查报名':'活动需求调查'" width="40%" :visible.sync="dialogTableVisible">
	    <el-form v-loading="loadings" :model="dataForm" ref="dataForm" :rules="rules">
           <el-form-item label="活动主题" label-width="80px" prop="title">
              <el-select v-if="info.baoming==0" v-model="dataForm.title" placeholder="请选择" style="width: 60%;">
                  <el-option
                    v-for="item in zhutiarr"
                    :key="item.title"
                    :label="item.title"
                    :value="item.title">
                  </el-option>
                </el-select>
				<span v-if="info.baoming==1">
					{{dataForm.title}}
				</span>
          </el-form-item>
		  <el-form-item label="开始时间" label-width="80px" prop="beginTime">
		      <el-date-picker v-if="info.baoming==0"  style="width: 60%;"
		            v-model="dataForm.beginTime"
		            type="datetime"
		            placeholder="选择开始时间" value-format="timestamp">
		          </el-date-picker>
				  <span v-if="info.baoming==1">{{dataForm.beginTime}}</span>
		  </el-form-item>
		  <el-form-item label="结束时间" label-width="80px" prop="endTime">
		      <el-date-picker v-if="info.baoming==0" style="width: 60%;"
		            v-model="dataForm.endTime"
		            type="datetime"
		            placeholder="选择结束时间" value-format="timestamp">
		          </el-date-picker>
				  <span  v-if="info.baoming==1">{{dataForm.endTime}}</span>
		  </el-form-item>
		  <el-form-item label="地区" label-width="80px" prop="address">
		      <el-cascader v-if="info.baoming==0" style="width: 60%;"
				   :options="areaSelectData"
				   @change="handleChange"
				   class="full-width"
				   size="large"
				   v-model="dataForm.address"
				   placeholder="请选择地区"
					/>
				<span>{{dataForm.address}}</span>
		  </el-form-item>
		  <el-form-item label="详细地址" label-width="80px" prop="addressdetail">
			  <el-input v-if="info.baoming==0" placeholder="请输入详细地址"  style="width: 60%;" v-model="dataForm.addressdetail"></el-input>
		     <span  v-if="info.baoming==1">{{dataForm.addressdetail}}</span>
		  </el-form-item>
		  <el-form-item>
		     <div style="width: 100%;display: flex;align-items: center;justify-content: center;margin-top: 10px;">
			  <el-button @click="dialogTableVisible=false">取消</el-button>
		       <el-button v-if="info.baoming==0" type="primary" style="width: 100px;height: 40px;" @click="save()">提交</el-button>
		     </div>
		  </el-form-item>
	    </el-form>
	</el-dialog>
</template>

<script>
	import { zhuti_list,user_huodong_save,user_baoming_find } from "@/api/news"
import { regionData, CodeToText, TextToCode } from "element-china-area-data";
	export default{
		data(){
			return{
				dialogTableVisible:false,
				dataForm:{
					title:'',//活动主题
					beginTime:'',//开始时间
					endTime:'',//结束时间
					address:'',//地址
					addressdetail:'',//详细地址
					hdid:'',//活动id
				},
				rules:{
					title:[{ required: true, message: '请选择活动主题', trigger: 'blur' }],
					beginTime:[{ required: true, message: '请选择开始时间', trigger: 'blur' }],
					endTime:[{ required: true, message: '请选择结束时间', trigger: 'blur' }],
					address:[{ required: true, message: '请选择地区', trigger: 'blur' }],
					addressdetail:[{ required: true, message: '请输入详细地址', trigger: 'blur' }],
				},
				
				zhutiarr:[],
				
				areaSelectData: regionData,//省市区三级联动数据
				
				info:{
					baoming:0
				},
				
				loadings:false
			}
		},
		watch:{
			dialogTableVisible(e){
				if(e==false){
						this.dataForm={
						title:'',//活动主题
						beginTime:'',//开始时间
						endTime:'',//结束时间
						address:'',//地址
						addressdetail:'',//详细地址
						hdid:'',//活动id
					}
					this.info = {
						baoming:0
					}
				}else{
					this.zhuti_list();
				}
			},
		},
		mounted(){
			
		},
		methods:{
			handlecreate(info){
				this.dialogTableVisible = true
				this.info = info?info:null
				if(info.baoming==1){
					//查看报名的信息
					this.user_baoming_find();
				}else{
				this.dataForm.hdid = info.id	
				}
				
			},
			user_baoming_find(){
				this.loadings = true
				user_baoming_find({
					hdid:this.info.id
				}).then(res=>{
					this.loadings = false
					console.log("成功",res.data);
					this.dataForm = res.data
				}).catch(()=>{
					this.loading = false
				})
			},
			zhuti_list(){
				zhuti_list({}).then(res=>{
					console.log("主题列表",res.data);
					this.zhutiarr = res.data
				})
			},
			//提交方法
			async save(){
			  let that = this;
			  that.$refs['dataForm'].validate((valid) => {
			    if (valid) {
			        const loading = this.$loading({
			            lock: true,
			            text: '提交中',
			            spinner: 'el-icon-loading',
			            background: 'rgba(0, 0, 0, 0.7)'
			          });
					  that.dataForm.beginTime = that.dataForm.beginTime/1000
					  that.dataForm.endTime = that.dataForm.endTime/1000
			        user_huodong_save(that.dataForm).then(()=>{
						loading.close();
						this.$message.success("成功");
						this.dialogTableVisible = false
						this.emit("tijiaosu");
					}).catch(()=>{
						loading.close();
					})
			    } else {
			      console.log("error");
			    }
			  })
			},
			handleChange(value) {
			      //value为省市区code数组
			      if (value) {
			        var provinceCode = CodeToText[value[0]];//code转为省
			        var cityCode = CodeToText[value[1]];//市
			        var orgion = CodeToText[value[2]];//区
			        this.dataForm.address = provinceCode + cityCode + orgion;
			      }
			},
		},
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/news/form/baoming.vue